export default "__VITE_ASSET__DJhaxWF6__"